import React from 'react';
export const CurrentLangContext = React.createContext();